import React, { useEffect, useState } from 'react';
import { googleConfig } from '../../lib/api';

const GoogleSection = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { googleConfig().then(setCfg).catch(() => setCfg({ client_id: null })); }, []);
  const origem = window.location.origin;

  return (
    <section className="bg-white rounded-2xl border border-slate-100 p-6 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-900">Login com Google</h2>
      <p className="text-sm text-slate-500 mb-4">O botão “Continuar com Google” aparece no login e no cadastro.</p>
      {cfg && (
        <p className={`text-sm font-medium ${cfg.client_id ? 'text-emerald-600' : 'text-red-600'}`}>
          {cfg.client_id ? 'Ativo: Client ID configurado no servidor.' : 'Inativo: falta o GOOGLE_CLIENT_ID no servidor.'}
        </p>
      )}
      {cfg?.client_id && <p className="text-xs text-slate-500 mt-1 break-all">Client ID: {cfg.client_id}</p>}
      <div className="mt-5 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 space-y-2">
        <p className="font-semibold text-slate-800">Para funcionar, no Google Cloud Console:</p>
        <p>APIs e serviços → Credenciais → seu ID de cliente OAuth → <strong>Origens JavaScript autorizadas</strong>. Adicione:</p>
        <ul className="list-disc pl-5 font-mono text-xs">
          <li>{origem}</li>
          <li>https://www.innovaenvios.app</li>
        </ul>
      </div>
    </section>
  );
};

export default GoogleSection;
